<script setup lang="ts">
import { computed } from 'vue';

import BootstrapModal from '../bootstrap-modal.vue';

const props = defineProps<{
    url?: string;
    text?: string;
    title?: string;
}>();
//eslint-obsolete no-spaced-func
const emit = defineEmits<{
    (event: 'update:url', value: string | undefined): void;
    (event: 'update:text', value: string | undefined): void;
    (event: 'dialog-closed'): void;
}>();
const showDialog = computed({
    get: () => !!(props.url || props.text),
    set: (val) => {
        if(!val) {
            emit('update:url', undefined);
            emit('update:text', undefined);
        }
    },
});
</script>

<template>
    <BootstrapModal
        v-if="showDialog"
        v-model:model-value="showDialog"
        :title="props.title"
        :size="props.url ? 'modal-fullscreen-no-padding' : 'modal-fullscreen'"
        close
        hide-footer
        @dialog-closed="emit('dialog-closed')"
    >
        <iframe v-if="props.url" class="viewer-frame" :src="props.url" />
        <textarea v-if="props.text" class="form-control viewer-text" readonly :value="props.text" />
    </BootstrapModal>
</template>
<style scoped>
.viewer-frame {
  width: 100%;
  height: 100%;
  border: 0 none;
  display: block;
}
.viewer-text {
  width: 100%;
  height: 100%;
  white-space:pre;
  overflow-wrap:normal;
  overflow-x:scroll;
}
</style>
